import PropTypes from 'prop-types';
import React from 'react';
import GroupLogo from '../../../../Groups/GroupLogo/GroupLogo';
import UnreadCount from '../UnreadCount/UnreadCount';

import './GroupOverview.scss';

export default class GroupOverview extends React.PureComponent {
    static propTypes = {
        /**
         * data for channel that is going to be displayed
         */
        displayData: PropTypes.object.isRequired,
        /**
         * css class that would override the existing styles
         */
        className: PropTypes.string,
        /**
         * count of unread message in a channel
         */
        unread: PropTypes.number.isRequired,
        /**
         * boolean to show unread count, shouldn't show in group header
         */
        shouldShowUnreadCount: PropTypes.bool,
    };

    static defaultProps = {
        displayData: {},
        className: '',
        shouldShowUnreadCount: true,
    };

    render() {
        const { className, displayData, unread } = this.props;

        return (
            <div
                className={`component-Messages-ChannelList-Channel-GroupOverview ${className}`}
            >
                <div className="logo-wrapper">
                    <GroupLogo logo={displayData.logo} />
                </div>
                <div className="group-meta">
                    <p className="group-name">{displayData.name}</p>
                    {this.props.shouldShowUnreadCount && (
                        <UnreadCount unread={unread} />
                    )}
                </div>
            </div>
        );
    }
}
